<template></template>
<script setup>
  import {useRouter}              from 'vue-router';
  import NotificationsController  from '@/js/Webmail/Notifications/NotificationsController';

  const router  = useRouter();

  NotificationsController.addError("notifications.page_not_found");
  router.push("/");
</script>